import { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import api from "@/lib/api";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import { StatusPill } from "@/pages/admin/Dashboard";
import { timeAgo, catLabel } from "@/lib/format";

const TABS = [["", "All"], ["awaiting_review", "Awaiting Review"], ["draft", "Drafts"],
  ["scheduled", "Scheduled"], ["published", "Published"], ["archived", "Archived"]];

export default function Articles() {
  const [tab, setTab] = useState("");
  const [items, setItems] = useState([]);
  const nav = useNavigate();
  const load = useCallback(() => {
    api.get(`/admin/articles${tab ? `?status=${tab}` : ""}`).then((r) => setItems(r.data || [])).catch(() => {});
  }, [tab]);
  useEffect(() => { load(); }, [load]);

  const createNew = async () => {
    const { data } = await api.post("/admin/articles", { headline: "Untitled draft", category: "fintech", content_type: "News" });
    nav(`/admin/articles/${data.id}`);
  };

  return (
    <AdminLayout title="Articles">
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-1 flex-wrap">
          {TABS.map(([val, label]) => (
            <button key={val} onClick={() => setTab(val)} data-testid={`articles-tab-${val || "all"}`}
              className={`px-3 py-1.5 text-xs uppercase tracking-wider border ${tab === val ? "border-cyan text-cyan bg-cyan/5" : "border-admborder text-admtext2 hover:text-admtext"}`}>{label}</button>
          ))}
        </div>
        <button onClick={createNew} data-testid="new-article-button" className="flex items-center gap-1.5 bg-crimson text-white px-4 py-2 text-xs font-bold uppercase tracking-wider hover:bg-crimsonhover"><Plus size={14} /> New Article</button>
      </div>

      <div className="bg-admcard border border-admborder">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-admmuted text-xs uppercase tracking-wider border-b border-admborder">
            <th className="px-5 py-3 font-medium">Headline</th><th className="px-3 py-3 font-medium">Category</th>
            <th className="px-3 py-3 font-medium">Type</th><th className="px-3 py-3 font-medium">Author</th>
            <th className="px-3 py-3 font-medium">Updated</th><th className="px-3 py-3 font-medium">Status</th>
          </tr></thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} onClick={() => nav(`/admin/articles/${a.id}`)} data-testid={`article-row-${a.id}`}
                className="border-b border-admborder last:border-0 hover:bg-admcardh cursor-pointer">
                <td className="px-5 py-3 text-admtext max-w-md truncate">
                  {a.headline}{a.ai_generated && <span className="ml-2 text-[9px] text-cyan border border-cyan/40 px-1 uppercase">AI</span>}
                  {a.fact_check?.verdict === "review" && <span className="ml-2 text-[9px] text-amber border border-amber/40 px-1 uppercase">FC</span>}
                </td>
                <td className="px-3 py-3 text-admtext2">{catLabel(a.category)}</td>
                <td className="px-3 py-3 text-admtext2">{a.content_type}</td>
                <td className="px-3 py-3 text-admtext2 text-xs">{a.author_name || "—"}</td>
                <td className="px-3 py-3 text-admmuted font-mono text-xs">{timeAgo(a.updated_date || a.created_at)}</td>
                <td className="px-3 py-3"><StatusPill status={a.status} /></td>
              </tr>
            ))}
            {!items.length && <tr><td colSpan={6} className="px-5 py-8 text-admmuted text-center">No articles in this view.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
